<style scoped lang="less">
  .login {
    background: #f3f3f4;
    text-align: center;
    padding: 100px 0 0 0;

    .modalSms {

      h2 {
        margin: 0 auto 40px auto;
      }

      form {
        text-align: left;
      }

      width: 320px;
      margin: auto;
    }
  }
</style>
<template>
  <div class="login" :style="{height: height}">
    <div class="modalSms">

      <h2>{{ welcomeText }}</h2>

      <i-form ref="loginForm" :model="loginForm">
        <Form-item prop="mobile">
          <Input v-model="loginForm.mobile" size="large" placeholder="请输入手机号" disabled="true"></Input>
        </Form-item>
        <Form-item prop="password">
          <Input type="text" v-model="loginForm.password" size="large" placeholder="请输入验证码" @on-enter="submit" style="width: 50%"/>
          <i-button v-show="show" type="info" @click="getCode">获取验证码</i-button>
          <i-button v-show="!show" type="info" class="count">{{count}} s</i-button>
        </Form-item>
        <Form-item style="margin-bottom: 10px">
          <i>二次身份验证</i>
        </Form-item>
        <Form-item>
          <i-button type="info" long @click="submit">提交</i-button>
        </Form-item>
      </i-form>
    </div>
  </div>
</template>

<script>
  export default {
    mounted: function () {
      this.height = window.innerHeight + 'px'
      window.onresize = () => {
        this.height = window.innerHeight + 'px'
      }

      if (this.$route.query.backUrl) {
        this.backUrl = this.$route.query.backUrl
      }
    },
    data () {
      return {
        backUrl: '/',
        height: '1200px',
        loginForm: {
          mobile: this.$store.get('mobile'),
          password: '',
          remember: false,
          code: '',
        },
        ruleValidate: {
          mobile: [
            {required: true, message: '手机号不能为空', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '验证码不能为空', trigger: 'blur'}
          ]
        },
        show: true,
        count: '',
        timer: null
      }
    },
    computed: {
      welcomeText () {
        if (window.location.hostname.indexOf('ququkid.com') > -1) {
          return '欢迎使用趣趣ABC管理系统'
        }
        return '欢迎使用HelloKid学员管理系统'
      }
    },
    methods: {
      submit () {
        var self = this
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            const f = self.loginForm
            f.phone = f.mobile
            f.mobile = self.$store.get('_account')
            f.code = self.$store.get('_wechatCode')
            self.$http.post('/adminUser/doSmsLogin', f).then(function (res) {
              if (res && res.data) {
                self.$store.set('token', res.data.token)
                self.$store.set('mobile', res.data.account)
                self.$store.set('id', res.data.id)
                self.$store.set('depLeader', res.data.depLeader)
                self.$store.set('adminRule', res.data.adminRule)
                self.$store.set('permissions', res.data.permissions)
                if (res.data.adviserInfo) {
                  self.$store.set('adviserInfo', res.data.adviserInfo)
                } else {
                  self.$store.remove('adviserInfo')
                }
                if (self.loginForm.remember) {
                  self.$store.set('password', res.data.password)
                }
                self.$Message.success('登录成功!')
                if (self.backUrl.indexOf('login') > -1) {
                  self.$router.push('/')
                } else {
                  self.$router.push(self.backUrl)
                }
              }
            })
          }
        })
      },
      getCode () {
        let self = this
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            self.$http.post('/adminUser/getSmsCode', self.loginForm).then(function (res) {
              if (res && res.status === 'ok') {
                if (!self.timer) {
                  self.count = 60
                  self.show = false
                  self.timer = setInterval(() => {
                    if (self.count > 0 && self.count <= 60) {
                      self.count--
                    } else {
                      self.show = true
                      clearInterval(self.timer)
                      self.timer = null
                    }
                  }, 1000)
                }
              } else {
                self.$Message.error(res.msg)
              }
            })
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// LoginSms.vue?00d3a092